module.exports = __webpack_public_path__ + "static/CircularStd-BookItalic-4a1311e9a9290c144a06258c9aadd7bc.ttf";